"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
exports.DateField = function (_a) {
  var field = _a.field,
    tag = _a.tag,
    editable = _a.editable,
    render = _a.render,
    otherProps = __rest(_a, ["field", "tag", "editable", "render"]);
  if (!field || !field.editable && !field.value) {
    return null;
  }
  var children;
  var htmlProps = __assign({}, otherProps);
  if (field.editable && editable) {
    htmlProps.dangerouslySetInnerHTML = {
      __html: field.editable
    };
  } else if (render) {
    children = render(field.value ? new Date(field.value) : null);
  } else {
    children = field.value;
  }
  if (tag || field.editable && editable) {
    return react_1.default.createElement(tag || 'span', htmlProps, children);
  } else {
    return react_1.default.createElement(react_1.default.Fragment, null, children);
  }
};
exports.DateField.propTypes = {
  field: prop_types_1.default.shape({
    value: prop_types_1.default.any,
    editable: prop_types_1.default.string
  }).isRequired,
  tag: prop_types_1.default.string,
  editable: prop_types_1.default.bool,
  render: prop_types_1.default.func
};
exports.DateField.defaultProps = {
  editable: true
};
exports.DateField.displayName = 'Date';